import { render, staticRenderFns } from "./listpengajuan.vue?vue&type=template&id=10c56ce4&"
import script from "./listpengajuan.vue?vue&type=script&lang=js&"
export * from "./listpengajuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports